import makeStyles from "@mui/styles/makeStyles";

const EASE = "180ms cubic-bezier(0.2, 0.8, 0.2, 1)";

const useStyles = makeStyles((theme) => {
  const INK = theme.palette.common.black;
  const RED = theme.palette.primary.main;

  return {
    field: {
      marginBottom: 20,
    },
    labelRow: {
      display: "flex",
      alignItems: "baseline",
      justifyContent: "space-between",
      gap: 12,
      marginBottom: 8,
    },
    label: {
      display: "block",
      fontSize: "0.8125rem",
      fontWeight: 700,
      letterSpacing: "0.01em",
      color: theme.palette.grey[600],
    },

    // Brand-red link with an underline that draws in on hover / focus.
    inkLink: {
      color: RED,
      fontWeight: 700,
      textDecoration: "none",
      backgroundImage: "linear-gradient(currentColor, currentColor)",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "0 100%",
      backgroundSize: "0% 2px",
      paddingBottom: 1,
      transition: `background-size ${EASE}`,
      "&:hover, &:focus-visible": {
        backgroundSize: "100% 2px",
      },
      "&:focus-visible": {
        outline: `2px solid ${RED}`,
        outlineOffset: 3,
        borderRadius: 2,
      },
    },
    forgot: {
      fontSize: "0.8125rem",
    },

    // Black button with a hard red offset shadow: lifts on hover, presses
    // flat into the page on click.
    signIn: {
      height: 56,
      marginTop: 8,
      borderRadius: 14,
      backgroundColor: INK,
      color: theme.palette.common.white,
      fontSize: "0.9375rem",
      fontWeight: 700,
      letterSpacing: "0.08em",
      boxShadow: `4px 4px 0 ${RED}`,
      transition: `transform ${EASE}, box-shadow ${EASE}`,
      "&:hover": {
        backgroundColor: INK,
      },
      "@media (hover: hover)": {
        "&:hover": {
          transform: "translate(-2px, -2px)",
          boxShadow: `6px 6px 0 ${RED}`,
        },
        "&:hover $arrow": {
          transform: "translateX(4px)",
        },
      },
      "&:active": {
        transform: "translate(3px, 3px)",
        boxShadow: `1px 1px 0 ${RED}`,
      },
      "&.Mui-focusVisible": {
        outline: `3px solid ${theme.palette.primary.light}`,
        outlineOffset: 3,
      },
      "&.Mui-disabled": {
        backgroundColor: INK,
        color: theme.palette.common.white,
        boxShadow: `4px 4px 0 ${RED}`,
      },
    },
    arrow: {
      marginLeft: 10,
      fontSize: 20,
      transition: `transform ${EASE}`,
    },

    switchRow: {
      marginTop: 28,
      paddingTop: 22,
      borderTop: `1px dashed ${theme.palette.grey[300]}`,
      textAlign: "center",
      fontSize: "0.875rem",
      color: theme.palette.grey[600],
    },
    legal: {
      marginTop: 14,
      textAlign: "center",
      fontSize: "0.75rem",
      lineHeight: 1.6,
      color: theme.palette.grey[500],
    },
  };
});

export default useStyles;
